import { useEffect, useState, type ReactNode } from 'react';
import { useBrand } from '@/features/auth/useAuth';

/**
 * Image de logo qui s'efface, ou cède la place au repli fourni, quand le
 * fichier est absent ou illisible : jamais d'icône d'image cassée à l'écran.
 */
export function ImageLogo({
  src,
  alt,
  className,
  repli = null,
}: {
  src: string | null | undefined;
  alt: string;
  className?: string;
  repli?: ReactNode;
}) {
  const [illisible, setIllisible] = useState(false);

  // Une nouvelle adresse mérite une nouvelle tentative d'affichage.
  useEffect(() => setIllisible(false), [src]);

  if (!src || illisible) return <>{repli}</>;
  return <img src={src} alt={alt} className={className} onError={() => setIllisible(true)} />;
}

/**
 * Logo de l'organisation, téléversé dans Paramètres › Marque. Rien tant que la
 * marque n'est pas connue, pour ne pas montrer le repli puis le logo ; ensuite
 * le repli fourni, s'il n'y a pas de logo ou que le fichier est illisible.
 */
export function LogoMarque({
  className,
  repli = null,
  decoratif = false,
}: {
  className?: string;
  repli?: ReactNode;
  /** Vrai quand le nom de l'organisation est déjà écrit à côté : texte alternatif vide. */
  decoratif?: boolean;
}) {
  const { data: marque, isPending } = useBrand();
  if (isPending) return null;
  return (
    <ImageLogo
      src={marque?.logoUrl}
      alt={decoratif ? '' : (marque?.nomOrganisation ?? '')}
      className={className}
      repli={repli}
    />
  );
}
